var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import HLS from 'hls.js/dist/hls.light';
import styled from 'styled-components';
var Outer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  max-height: ", "%;\n\n  &:before {\n    display: block;\n    content: '';\n    width: 100%;\n    padding-top: ", "%;\n  }\n"], ["\n  position: relative;\n  max-height: ", "%;\n\n  &:before {\n    display: block;\n    content: '';\n    width: 100%;\n    padding-top: ", "%;\n  }\n"])), function (p) { return (p.height / p.width) * 100; }, function (p) { return (p.height / p.width) * 100; });
var Inner = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
export var Ratio = function (props) {
    return (_jsx(Outer, __assign({ width: props.width, height: props.height }, { children: _jsx(Inner, __assign({ style: {
                position: props.fixed ? 'fixed' : 'absolute'
            } }, { children: props.children })) })));
};
var hlsError = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.log('hlsError:', args);
};
var Player = function (props, ref) {
    var isDebug = props.isDebug, isPlaying = props.isPlaying, volume = props.volume, src = props.src, fileType = props.fileType, time = props.time, onPlayerTimeUpdate = props.onPlayerTimeUpdate, isEnded = props.isEnded;
    var videoRef = useRef(null);
    var _a = useState(0), currentTime = _a[0], setCurrentTime = _a[1];
    var _b = useState(), hls = _b[0], setHls = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(0), videoVolume = _d[0], setVideoVolume = _d[1];
    useEffect(function () {
        var handler = function (e) {
            e.preventDefault();
        };
        videoRef.current.addEventListener('contextmenu', handler);
        return function () {
            videoRef.current.addEventListener('contextmenu', handler);
        };
    }, []);
    useEffect(function () {
        setVideoVolume(volume);
        var video = videoRef.current;
        if (video) {
            video.muted = volume === 0;
        }
    }, [volume]);
    useImperativeHandle(ref, function () { return ({
        get video() {
            return videoRef.current;
        }
    }); }, []);
    useEffect(function () {
        setCurrentTime(time);
        var video = videoRef.current;
        if (video) {
            video.currentTime = time;
        }
    }, [time, isEnded]);
    useEffect(function () {
        var video = videoRef.current;
        if (video) {
            if (isPlaying) {
                if ((video.readyState === 1 || video.readyState === 4) && isPlaying) {
                    video.play();
                }
            }
            else {
                if (video.readyState > 0) {
                    video
                        .play()
                        .then(function () {
                        video.pause();
                    })
                        .catch(function (e) {
                        console.log('Error pausing video', e);
                    });
                }
                else {
                    video.pause();
                }
            }
        }
    }, [isPlaying]);
    useEffect(function () {
        var hls;
        if (videoRef.current) {
            var video_1 = videoRef.current;
            if (video_1) {
                video_1.addEventListener('play', function (e) {
                    setIsLoading(false);
                });
                video_1.addEventListener('seeking', function (e) {
                    setIsLoading(true);
                });
                video_1.addEventListener('seeked', function (e) {
                    setIsLoading(false);
                });
                video_1.addEventListener('loadeddata', function (e) {
                    if (video_1.readyState >= 3 && isPlaying === true) {
                        video_1.play();
                    }
                    else {
                        video_1.pause();
                    }
                });
                if (video_1.canPlayType('application/vnd.apple.mpegurl')) {
                }
                else if (fileType === 'mp4') {
                    video_1.src = src;
                }
                else if (HLS.isSupported()) {
                    hls = new HLS({ debug: isDebug });
                    if (video_1) {
                        if (hls) {
                            hls.attachMedia(video_1);
                            hls.loadSource(src);
                            hls.off(HLS.Events.ERROR, hlsError);
                            hls.on(HLS.Events.ERROR, function (event, data) {
                                if (data.fatal) {
                                    switch (data.type) {
                                        case HLS.ErrorTypes.NETWORK_ERROR:
                                            console.log('fatal network error encountered, try to recover');
                                            hls.startLoad();
                                            break;
                                        case HLS.ErrorTypes.MEDIA_ERROR:
                                            console.log('DATA', data);
                                            console.log('fatal media error encountered, try to recover');
                                            hls.recoverMediaError();
                                            break;
                                        default:
                                            hls.destroy();
                                            break;
                                    }
                                }
                            });
                        }
                    }
                    setHls(hls);
                    hls.attachMedia(video_1);
                }
                else {
                    console.error("This is a legacy browser that doesn't support MSE");
                }
            }
        }
        return function () {
            if (hls) {
                hls.destroy();
            }
        };
    }, [src, fileType, isDebug]);
    return (_jsx("div", __assign({ style: {
            height: '100%'
        } }, { children: _jsx("video", { autoPlay: false, ref: videoRef, style: {
                width: '100%',
                height: '100%'
            }, onTimeUpdate: function (e) {
                onPlayerTimeUpdate(e.target.currentTime);
            } }) })));
};
export default React.forwardRef(Player);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map